import router from "../router";

export const redirectToLogin = async () => {
  if (router.currentRoute.value.path === "/login") {
    return;
  }

  await router.replace({
    path: "/login",
    query: {
      redirect: router.currentRoute.value.fullPath,
    },
  });
};
